import React from 'react';
import { compose } from 'ramda';
import { onlyUpdateForKeys } from 'recompose';
import { mergeClassNames } from 'js/utils/classNameBuilder.util';
import RaceProperty from '../../RaceProperty';
import withRaceCountDown from '../withRaceCountDown';
import style from './index.scss';

export const highlightedStyle = isHighlighted => isHighlighted ? { value: style.highlighted } : {};

export const CountDownBadge = ({ isHighlighted, color = 'dark', label, value, className = '' }) => (
    <RaceProperty
        label={label}
        value={value}
        className={`${style.badge} ${style[color] || ''} ${className}`}
        classNames={mergeClassNames(['label', 'value'], style, highlightedStyle(isHighlighted))}
    />
);

export default compose(
    withRaceCountDown,
    onlyUpdateForKeys(['value', 'isHighlighted'])
)(CountDownBadge);
